import {ProductOverview} from "../models/Product";
import {ProductQuantityByDayReportTemplateData} from "./ProductQuantityByDayReportTemplateData";
import {ProductQuantityByDayReportImportTemplate} from "./ProductQuantityByDayReportImportTemplate";
import {cloneDeep} from "lodash";

export const getProductQuantityByDayReportTemplate = (
    reportMercantileData: ProductOverview[],
    reportRepromaterialData: ProductOverview[],
    selectedWarehouse: string,
    date: Date
    ) => {
    return ProductQuantityByDayReportImportTemplate(prepareData(reportMercantileData, reportRepromaterialData, selectedWarehouse, date));
};

const prepareData = (
        reportMercantileData: ProductOverview[],
        reportRepromaterialData: ProductOverview[],
        selectedWarehouse: string,
        date: Date
    ) => {
    const templateData: ProductQuantityByDayReportTemplateData = {
        reportMercantileData: cloneDeep(reportMercantileData),
        reportRepromaterialData: cloneDeep(reportRepromaterialData),
        selectedWarehouse: selectedWarehouse,
        date: date
    };

    return templateData;
};